module.exports = __webpack_public_path__ + "static/media/02_Special_Ep6.344139b6.jpg";